export default {
  SHOW_LINKED_CALENDAR: 'VISITS.SHOW_LINKED_CALENDAR',
  HIDE_LINKED_CALENDAR: 'VISITS.HIDE_LINKED_CALENDAR',
}
